import React from 'react'
import '../../../Css/Notification_Homepage.scss'
import NotifPicture from '../PhotoUser'

function Notification() {
    
    return (
        <div className= "notficationWrapper">
        <h4>Notification</h4>
        <ul>
            <li>
                <div className="pict">
                    <NotifPicture/>
                </div>
                <div className= "notifDesc">
                    <h5>Admin</h5>
                    <div>
                        <p  tabIndex="0" >Lorem ipsum dolor sit amet consectetur, adipisicing elit. In, exercitationem. Exercitationem obcaecati culpa quod reprehenderit quo aperiam facilis dolore, doloribus voluptas, earum quae id porro beatae quos dignissimos consequatur laborum.</p>
                    </div>
                    <a href="#">5 Minutes Ago</a>
                </div> 
            </li>
             <li>
                <div className="pict">
                    <NotifPicture/>
                </div>
                <div className= "notifDesc">
                    <h5>Admin</h5>
                    <div>
                        <p  tabIndex="0" >Lorem ipsum dolor sit amet consectetur, adipisicing elit. In, exercitationem. Exercitationem obcaecati culpa quod reprehenderit quo aperiam facilis dolore, doloribus voluptas, earum quae id porro beatae quos dignissimos consequatur laborum.</p>
                    </div>
                    <a href="#">5 Minutes Ago</a>
                </div> 
            </li>
            
        </ul>
    </div>
    )
}

export default Notification
